import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import FormPage from './pages/FormPage'
import StandalonePage from './pages/StandalonePage'
import AdminPage from './pages/AdminPage'
import NotFoundPage from './pages/NotFoundPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public form route (linked to Jobber job) */}
        <Route path="/form/:shortCode" element={<FormPage />} />
        
        {/* Standalone form route (no Jobber job required) */}
        <Route path="/standalone/:tenantId" element={<StandalonePage />} />
        
        {/* Admin dashboard */}
        <Route path="/admin" element={<AdminPage />} />
        
        {/* Root redirect to admin */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
        
        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
